import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'eui-card-content',
    templateUrl: './eui-card-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardContentComponent {

    @HostBinding('class') string = 'eui-card-content';
    @HostBinding('attr.tabindex') tabindex = '0';

    constructor( ) {
    }
}
